import { Routes } from '@angular/router';
import { RoleGuardService } from './services/role-guard.service';
import { ForbiddenComponent } from './modules/shared/pages/forbidden.component';

export const AppRoutes: Routes = [
  { path: '', redirectTo: 'auth', pathMatch: 'full', canActivate: [RoleGuardService] },
  { path: 'auth', loadChildren: './modules/auth/auth.module#AuthModule' },
  { path: 'webview', loadChildren: './modules/webview/webview.module#WebviewModule' },
  { path: '', loadChildren: './app-modules/dashboard/dashboard.module#DashboardModule' },
  { path: '', loadChildren: './app-modules/editores/editores.module#EditoresModule' },
  { path: '', loadChildren: './modules/relatorios/relatorios.module#RelatoriosModule' },
  {
    path: 'erros',
    children: [{
      path: ' ',
      component: ForbiddenComponent
    }]
  }
];



// WEBPACK FOOTER //
// ./src/app/app.routing.ts